import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import config from "../../config";

const canStartFetch = (url, method, body) => {
  if (!url || url.includes("null") || url.includes("undefined")) return false;
  if (method && body === null) return false;
  return true;
};

const useFetch = ({ url, body = null, method, contentType = true, reFetch, isMobile = false, accessibility = 'Edit' }) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(() => canStartFetch(url, method, body));
  const token = useSelector((state) => state.token);
  useEffect(() => {
    console.log("url", url, method, body);
    if (!canStartFetch(url, method, body)) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    setResponse(null);
    const controller = new AbortController();
    const fetchData = async () => {
      const header = {
        method: method || "GET",
        headers: {
          Authorization: token.token,
        },
        credentials: "same-origin",
        signal: controller.signal,
      };
      if (contentType) header.headers["Content-Type"] = "application/json";
      if (body) header.body = body;
      try {
        if (accessibility === 'Edit') {
          let resok = true;

          const res = await fetch(`${isMobile ? config.mobileurl : config.devurl}${url}`, header);
          const json = await res.json();
          if (controller.signal.aborted) return;
          resok = res.ok;
          if (/4[0-9]{2}/i.test(res.status) || /5[0-9]{2}/i.test(res.status)) {
            setError(json.error || json.message || res.statusText);
            setIsLoading(false);
            return;
          }
          if (controller.signal.aborted) return;
          resok ? setResponse(json) : setError(json.error || res.statusText);
          setIsLoading(false);
        }
        else {
          setError({ "error": "You are not Authorized to perform this action" });
          setIsLoading(false);
        }
      } catch (error) {
        if (error.name === "AbortError") return;
        console.log("url", error, url);
        setError(error);
        setIsLoading(false);
      }
    };
    fetchData();
    return () => controller.abort();
  }, [url, body, contentType, token, reFetch]);
  return { response, error, isLoading };
};

export default useFetch;
